module.exports = __webpack_public_path__ + "static/media/mars-red-moan.f32ec6aa.m4a";